'use strict';

const Index = require('./frontend/desktop/index');
const { documentReady } = require('@grpn/document-states');

documentReady.then(Index);
